module.exports = casinoRedux.studios.selectors;